const HomeRouter = [
  // Home banner
  {
    path: '/home-banner',
    name: 'Banner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Banner/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý home banner'
    }
  },

  // Home products
  {
    path: '/home-products',
    name: 'HomeProducts',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Products/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý product'
    }
  },
  {
    path: '/home-products/create',
    name: 'CreateHomeProduct',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Products/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới product'
    }
  },
  {
    path: '/home-products/:id/update',
    name: 'UpdateHomeProduct',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Products/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật product'
    }
  },

  //Home services
  {
    path: '/home-services',
    name: 'HomeServices',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Services/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý dịch vụ'
    }
  },
  {
    path: '/home-services/create',
    name: 'CreateHomeService',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Services/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới dịch vụ'
    }
  },
  {
    path: '/home-services/:id',
    name: 'UpdateHomeService',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Services/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật dịch vụ'
    }
  },

  // Home process
  {
    path: '/home-process',
    name: 'HomeProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Process/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý quy trình'
    }
  },
  {
    path: '/home-process/create',
    name: 'CreateProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Process/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới quy trình'
    }
  },
  {
    path: '/home-process/:id',
    name: 'UpdateHomeProcess',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Process/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật quy trình'
    }
  },

  // Home trying produce services
  {
    path: '/home-product-service-trying',
    name: 'HomeProductServiceTrying',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/ProductServiceTrying/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý sản phẩm - dịch vụ dùng thử'
    }
  },
  {
    path: '/home-product-service-trying/create',
    name: 'CreateHomeProductService',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/ProductServiceTrying/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới sản phẩm - dịch vụ'
    }
  },
  {
    path: '/home-product-service-trying/:id',
    name: 'UpdateHomeProductService',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/ProductServiceTrying/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật sản phầm - dịch vụ'
    }
  },

  // Home technology
  {
    path: '/home-technology',
    name: 'Technology',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Technology/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý công nghệ'
    }
  },
  {
    path: '/home-technology/create',
    name: 'CreateTechnology',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Technology/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới công nghệ'
    }
  },
  {
    path: '/home-technology/:id',
    name: 'UpdateTechnology',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Technology/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật công nghệ'
    }
  },

  // Home partner
  {
    path: '/home-partner',
    name: 'HomePartner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Partner/index.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Quản lý partner'
    }
  },
  {
    path: '/home-partner/create',
    name: 'CreateHomePartner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Partner/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Thêm mới partner'
    }
  },
  {
    path: '/home-partner/:id',
    name: 'UpdateHomePartner',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/Home/Partner/Controller.vue'),
    meta: {
      openSidebarKey: 'homepage',
      title: 'Cập nhật partner'
    }
  },

  {
		path: '/home-question',
		name: 'ManageQuestion',
		layout: "dashboard",
		component: () => import('@/views/LandingPage/Home/CustomerQuestion/index.vue'),
		meta: {
      openSidebarKey: 'homepage',
			title: 'Quản lý câu hỏi khách hàng'
		}
	},
]


export default HomeRouter;